import { FontSizes, getTheme, IconButton, mergeStyleSets, Modal } from '@fluentui/react';
import React from 'react';

const theme = getTheme();

const classNames = mergeStyleSets({
    container: {
        width: '90%',
        maxWidth: '420px',
        minWidth: '320px',
        margin: 'auto',
        backgroundColor: '#5cb3a3',
        borderRadius: '8px',
        color: theme.palette.white,
    },
    content: {
        position: 'relative',
        padding: `${theme.spacing.l2} ${theme.spacing.l1} ${theme.spacing.l2}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing.s1,
        right: theme.spacing.s1,
        color: theme.palette.white,
    },
    title: {
        fontSize: FontSizes.xLarge,
        fontWeight: 'bold',
        marginBottom: theme.spacing.l1,
    },
    message: {
        fontSize: FontSizes.mediumPlus,
        marginBottom: theme.spacing.l2,
    },
    button: {
        backgroundColor: '#f4d03f',
        border: 'none',
        borderRadius: '25px',
        padding: `${theme.spacing.s1} ${theme.spacing.l2}`,
        fontSize: FontSizes.medium,
        fontWeight: 'bold',
        color: '#333',
        minWidth: '180px',
        maxWidth: '250px',
        height: '50px',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        selectors: {
            ':hover': {
                backgroundColor: '#f1c40f',
            }
        }
    },
});

const LicenseOverlay = ({ title, text, button, onClose }) => {
    return (
        <Modal
            isOpen={true}
            onDismiss={onClose}
            isBlocking={true}
            isDarkOverlay={true}
            containerClassName={classNames.container}
            scrollableContentClassName={classNames.content}
        >
            <IconButton
                className={classNames.closeButton}
                iconProps={{ iconName: 'Cancel' }}
                onClick={onClose}
                ariaLabel="Close"
            />

            <div className={classNames.title}>{title}</div>

            <div className={classNames.message}>
                {text}
            </div>

            <button
                className={classNames.button}
                onClick={button.onClick}
            >
                {button.text}
            </button>
        </Modal>
    );
};

export default LicenseOverlay;
